export default __webpack_public_path__ + "static/media/28.d024e5f7.jpg";